import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';

const ScrollLockModal = ({ show, onHide, backdrop, size, className, children }) => {
    let ele = document.getElementsByClassName("App");

    
    useEffect(() => {
        if (show) {
            ele[0].classList.add("mystyle");
        } else {
            ele[0].classList.remove("mystyle");
        }
      }, [show]);


    return (
        <Modal
            backdrop={backdrop}
            size={size}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className={className}
            show={show} 
            onHide={onHide}

        >

            <Modal.Body>{children}</Modal.Body>

        </Modal>
    );
};

export default ScrollLockModal;
